import { Box, Card, CardContent, Chip, Stack } from '@mui/material';
import Typography from '@mui/material/Typography/Typography';
import { InsertDriveFile } from '@mui/icons-material';
import React from 'react';

interface Props {
  file: File;
}

export const TemplateFileStep = ({ file }: Props): React.JSX.Element => (
  <Card elevation={3}>
    <CardContent>
      <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
        <Box mr=".4rem">
          <InsertDriveFile sx={{ color: (theme) => theme.palette.primary.main, fontSize: '5em' }} />
        </Box>
        <Stack direction={'column'} spacing={2}>
          <Box mr=".8rem">
            <Typography variant={'caption'} style={{ fontSize: '1.2rem' }}>
              {file.name}
            </Typography>
          </Box>

          <Chip label={Number(file.size / 1024).toFixed(2) + 'kB'} />
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);
